import { IApiResponse, IPaginatedResponse } from "../../models";

// How the HTTP call to payment-action went.
export enum EAutoCashoutCallStatus {
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
  SKIPPED = "SKIPPED",
}

// What happened to the money.
export enum EAutoCashoutOutcome {
  CASHED_OUT_REQUESTED = "CASHED_OUT_REQUESTED",
  SKIPPED = "SKIPPED",
  FAILED = "FAILED",
}

export interface IAutoCashoutPaymentCall {
  id: string;
  runId: string;
  domainId: string;
  referenceTransactionId: string | null;
  beneficiaryId: string | null;
  beneficiaryName: string | null;
  amount: number | null;
  status: EAutoCashoutCallStatus;
  outcome: EAutoCashoutOutcome;
  reason: string | null;
  statusCode: number | null;
  transactionId: string | null;
  transactionStatus: string | null;
  statusDescription: string | null;
  dryRun: boolean;
  createdAt: string;
}

export type IAutoCashoutPaymentCallsResponse = IApiResponse<
  IPaginatedResponse<IAutoCashoutPaymentCall[]>
>;
